import { render } from "./App.vue?vue&type=template&id=1ca0be62"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1ca0be62&lang=scss"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__